import { render, staticRenderFns } from "./PageCreate.vue?vue&type=template&id=ba5c6740&scoped=true&"
import script from "./PageCreate.vue?vue&type=script&lang=ts&"
export * from "./PageCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5c6740",
  null
  
)

export default component.exports